/**
* @ngdoc service
* @name common.service:homeAnalitics
* @description
* description
*/
(function() {
  'use strict';

  angular
  .module('itxApp.common')
  .service('HomeAnalitics', homeAnalitics);

  homeAnalitics.$inject = [
    'ItxApiSvc',
    'imHomeService'
  ];

  function homeAnalitics (
    ItxApiSvc,
    imHomeService
  ) {

    var service =  {
      sendCategoryPath: sendCategoryPath,
      sendPathStatic: sendPathStatic,
      sendPathHttp: sendPathHttp,
      createProductEvent: createProductEvent,
      createPopupViewBundle: createPopupViewBundle,
      createView:createView,
      selectBundleProduct:selectBundleProduct,
      eventSelectSize:eventSelectSize
    };
    return service;

    function sendCategoryPath(id, name, type){
      ItxApiSvc.getCategoryTree().then(function(){
        imHomeService.createEventCategoryPath(id, name, null, type);
      });
    }

    function sendPathHttp(value, name, type) {
      imHomeService.createEventCategoryPath(null, name, value, type);
    }

    function sendPathStatic(value, name, type, cmp) {
      var categoryPath = null;
      if(value === '@ItxStoreLocatorPage') {
        categoryPath = '/localizador_tiendas/localizar/lista';
      } else if(value === '@women'){
        categoryPath = '/entrada/home/pagina_inicio_women';
      } else if(value === '@men'){
        categoryPath = '/entrada/home/pagina_inicio_men';
      } else if(value === '@bg'){
        categoryPath = '/entrada/home/pagina_inicio_boys&girls';
      } else {
        categoryPath = value;
      }
      imHomeService.createEventCategoryPath(null, name, categoryPath, type, cmp);
    }

    function createProductEvent(cmp, product) {
      imHomeService.createProductEvent(cmp, product); 
    }

    function createView(section) {
      imHomeService.createView(section); 
    }
    function createPopupViewBundle(bundle) {
      imHomeService.createPopupViewBundle(bundle); 
    }

    function selectBundleProduct(product) {
      imHomeService.selectBundleProduct(product);
    }

    function eventSelectSize(product, size) {
      imHomeService.eventSelectSize(product, size);
    }   

  }

})();